<script setup>
import { ref, onMounted, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from "primevue/useconfirm"
import { FilterMatchMode } from 'primevue/api'
import { useRouter } from 'vue-router'
import axios from 'axios'

/////////////////////
// Interface Props //
/////////////////////
const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()
const router = useRouter()

const emits = defineEmits(['chatCallback'])

const props = defineProps({
    company_id: { type: String, required: true }
})


const users = ref([])
const planers = ref([])
const projectmanagers = ref([])
const poliers = ref([])
const measurers = ref([])
const contacts = ref([])
const stages = ref([])
const types = ref([])
const activities = ref([])
const stage_fields = ref([])
const tab_counter_company = ref(0)
const tab_counter_stage = ref(0)
const change_stage_id = ref(null)


const company = ref({})
const pipeline = ref("stRmVwTD")

const edit_company_slider = ref(false)
const create_deal_dialog = ref(false)

const get_users = () => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-users')
    .then(response => {
        console.log("users", response.data)
        users.value = response.data
        loader.value = false
        // filter if user is in a team from array called teams
        planers.value = users.value.filter(user => user.teams.includes("Planer"))
        poliers.value = users.value.filter(user => user.teams.includes("Polier"))
        console.log("planers", planers.value)
    })
}

const get_user_full_name = (email) => {
    let full_name = ""
    let user = users.value.find(user => user.email == email)
    if (user) {
        full_name = user.first_name + " " + user.last_name
    }
    return full_name
}

const lead_sources = ref([
    {name: 'Telefon', value: 'Telefon'},
    {name: 'E-Mail', value: 'E-Mail'},
    {name: 'Homepage', value: 'Homepage'},
    {name: 'Persönlich', value: 'Persönlich'},
    {name: 'Whatsapp', value: 'Whatsapp'},
])

const neu_statuses = ref([
    {name: 'Offen', value: 'Offen'},
    {name: 'Termin vereinbart', value: 'Termin vereinbart'}
])

const save_neu_status = () => {
    if (company.value.neu_status == "Termin vereinbart") {
        confirm.require({
            message: 'Wurde mit dem Kunden ein Termin vereinbart?',
            header: 'Termin vereinbart',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ja, ein Termin wurde vereinbart',
            rejectLabel: 'Nein, noch nicht',
            acceptClass: 'p-button-danger',
            accept: () => {
                change_stage_id.value = "0k-3-Jtt"
                change_stage()
            }
        })
    }
    else {
        save_company()
    }
}

const save_offer_status = () => {
    if (company.value.offer_status == "Offerte angenommen") {
        confirm.require({
            message: 'Wurde die Offerte angenommen?',
            header: 'Offerte angenommen',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ja, die Offerte wurde angenommen',
            rejectLabel: 'Nein, noch nicht',
            acceptClass: 'p-button-danger',
            accept: () => {
                change_stage_id.value = "lUdzDYZU"
                change_stage()
            }
        })
    }
    else {
        save_company()
    }
}

const send_offer = () => {
    let project_cost = 0
    if (company.value.project_costs > 0) {
        project_cost = company.value.project_costs
    }
    else if (company.value.project_custom_costs > 0) {
        project_cost = company.value.project_custom_costs
    }
    confirm.require({
        message: 'Offerte für ' + String(project_cost) + ' CHF an <e-mail>, via E-Mail versenden?',
        header: 'Offerte senden',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Ja, Offerte senden',
        rejectLabel: 'Nein, noch nicht',
        acceptClass: 'p-button-danger',
        accept: () => {
            company.value.offer_status = "Offerte versendet"
        }
    })
}

const save_ausmessung = () => {
    if (company.value.ausmessung == true) {
        confirm.require({
        message: 'Vorprojekt für Aussmessung freigeben?',
        header: 'Ausmessung freigabe',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Ja, zur Ausmessung freigeben',
        rejectLabel: 'Nein, noch nicht',
        acceptClass: 'p-button-danger',
        accept: () => {
            if (company.value.gezeichnet == true) {
                change_stage_id.value = "xHCglsnL"
                change_stage()
            }
        }
    })
    } else {
        save_company()
    }
}

const save_gezeichnet = () => {
    if (company.value.gezeichnet == true) {
        confirm.require({
        message: 'Bestand wurde gezeichnet?',
        header: 'Bestand gezeichnet',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Ja, Bestand wurde gezeichnet',
        rejectLabel: 'Nein, noch nicht',
        acceptClass: 'p-button-danger',
        accept: () => {
            if (company.value.ausmessung == true) {
                company.value.kundenreaktion = "Offen"
                change_stage_id.value = "xHCglsnL"
                change_stage()
            }
        }
    })
    } else {
        save_company()
    }
}

const project_costs = ref([
    {name: "CHF 2'000.-", value: 2000},
    {name: "CHF 2'500.-", value: 2500},
    {name: "CHF 3'000.-", value: 3000},
    {name: "Sonnstiger Betrag", value: 0},
])

const send_offer_vias = ref([
    {name: 'E-Mail', value: 'E-Mail'},
    {name: 'Post', value: 'Post'},
    {name: 'Persönlich', value: 'Persönlich'},
    {name: 'SMS', value: 'SMS'},
    {name: 'Sonnstiges', value: 'Sonnstiges'}
])

const offer_statuses = ref([
    {name: 'Offerte versendet', value: 'Offerte versendet'},
    {name: 'Offerte angenommen', value: 'Offerte angenommen'},
    {name: 'Offerte abgelehnt', value: 'Offerte abgelehnt'},
    {name: 'Vorprojekt abgesagt', value: 'Vorprojekt abgesagt'}
])

const kundenreaktionen = ref([
    {name: 'Offen', value: 'Offen'},
    {name: 'Zufrieden', value: 'Zufrieden'},
    {name: 'Änderungswünsche', value: 'Änderungswünsche'}
])

const save_kundenreaktion = () => {
    if (company.value.kundenreaktion == "Änderungswünsche") {
        confirm.require({
            message: 'Wünscht der Kunde Änderungen?',
            header: 'Änderungswünsche',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ja, der Kunde wünscht Änderungen',
            rejectLabel: 'Nein, keine Änderungswünsche',
            acceptClass: 'p-button-danger',
            accept: () => {
                company.value.kundenreaktion = "Offen"
                company.value.entwurf_fertig = false
                company.value.planvariante_fertig = false
                save_company()
            }
        })
    } else if (company.value.kundenreaktion == "Zufrieden") {
        confirm.require({
            message: 'Ist der Kunde zufrieden?',
            header: 'Kundenreaktion',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ja, der Kunde ist zufrieden',
            rejectLabel: 'Nein, nicht zufrieden',
            acceptClass: 'p-button-danger',
            accept: () => {
                change_stage_id.value = "EJLT6DFM"
                change_stage()
            }
        })
    } else {
        save_company()
    }
}

const save_offerte_bereit = () => {
    if (company.value.offerte_bereit_zur_besprechung == true) {
        confirm.require({
            message: 'Ist die Offerte bereit?',
            header: 'Offerte bereit',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ja, die Offerte ist bereit',
            rejectLabel: 'Nein, noch nicht',
            acceptClass: 'p-button-danger',
            accept: () => {
                change_stage_id.value = "Y3-i-d8v"
                company.value.offertenstatus = "Offen"
                change_stage()
            }
        })
    } else {
        save_company()
    }
}

const offertenstatuses = ref([
    {name: 'Offen', value: 'Offen'},
    {name: 'Zusage', value: 'Zusage'},
    {name: 'Abgelehnt', value: 'Abgelehnt'},
    {name: 'Anpassung', value: 'Anpassen'}
])

const save_offertenstatus = () => {
    if (company.value.offertenstatus == "Anpassung") {
        confirm.require({
            message: 'Wünscht der Kunde Änderungen?',
            header: 'Änderungswünsche',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ja, der Kunde wünscht Änderungen',
            rejectLabel: 'Nein, keine Änderungswünsche',
            acceptClass: 'p-button-danger',
            accept: () => {
                company.value.offertenstatus = "Offen"
                change_stage_id.value = "EJLT6DFM"
                change_stage()
            }
        })
    } else if (company.value.offertenstatus == "Zusage") {
        confirm.require({
            message: 'Hat der Kunde zugesagt?',
            header: 'Kundenreaktion',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ja, der Kunde hat zugesagt',
            rejectLabel: 'Nein, keine Zusage',
            acceptClass: 'p-button-danger',
            accept: () => {
                change_stage_id.value = "cLKxdTib"
                change_stage()
            }
        })
    } else {
        save_company()
    }
}

const languages = ref([])
const salutations = ref([])

const get_salutations = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-salutations')
    .then(response => {
        salutations.value = response.data
        console.log("salutations", response.data)
    })
}

const get_languages = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-languages')
    .then(response => {
        languages.value = response.data
        console.log("languages", response.data)
    })
}

const get_salutation = (id) => {
    return salutations.value.find(salutation => salutation.id == id).label
}

const get_language = (id) => {
    return languages.value.find(language => language.id == id).label
}

onMounted( async () => {
    console.log("hello company component")
    get_languages()
    get_salutations()
    get_users()
    get_company()
    get_stages()
    get_company_types()
    get_activities()
    //get_company_files()
})

const check_required_fields_company = () => {
    let count = 0
    if (company.value.name == "" || company.value.name == null || company.value.name == undefined) {
        count++
    }
    if (company.value.street == "" || company.value.street == null || company.value.street == undefined) {
        count++
    }
    if (company.value.postal_code == "" || company.value.postal_code == null || company.value.postal_code == undefined) {
        count++
    }
    if (company.value.city == "" || company.value.city == null || company.value.city == undefined) {
        count++
    }
    console.log("check company", count)
    return count
}

const check_required_fields_stage = () => {
    let count = 0
    if (company.value.owner == "" || company.value.owner == null || company.value.owner == undefined) {
        count++
    }
    stage_fields.value.forEach(field => {
        if (field.required && !company.value.stage_fields[field.id] || field.required && company.value.stage_fields[field.id] == false || field.required && company.value.stage_fields[field.id] == "" || field.required && company.value.stage_fields[field.id] == null || field.required && company.value.stage_fields[field.id] == undefined) {
            count++
        }
    })
    console.log("check stage", count)
    return count
}

const get_company = () => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + "/gartenkultur/crm/get-company?company_id=" + props.company_id)
    .then (response => {
        console.log("company", response.data)
        company.value = response.data
        if (company.value.stage_fields == null) {
            company.value.stage_fields = {}
        }
        tab_counter_company.value = check_required_fields_company()
        contacts.value = response.data.contacts
        get_stage_fields(pipeline.value, company.value.stage_id)
        loader.value = false
    })
}

const get_stages = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-stages?pipeline=' + pipeline.value)
    .then(response => {
        stages.value = response.data
        console.log("stages", response.data)
    })
}

const edit_company = () => {
    edit_company_slider.value = true
}

const save_company = () => {
    loader.value = true
    console.log("save company")
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/save-company', company.value)
    .then(response => {
        console.log("company updated", response.data)
        edit_company_slider.value = false
        axios(get_company())
        .then(response => {
            loader.value = false
        })
        toast.add({severity: 'success', summary: 'Erfolg', detail: 'Objekt erfolgreich aktualisiert', life: 3000})
    })
}

const get_company_types = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-company-types')
    .then(response => {
        types.value = response.data
        console.log("types", response.data)
    })
}

const get_activities = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-activities?company_id=' + props.company_id)
    .then(response => {
        console.log("activities", response.data)
        activities.value = response.data
    })
}

const activity_index = ref(null)

const activity = ref("")
const edit_activity_dialog = ref(false)
const edit_activity = (index) => {
    activity.value = activities.value[index].content
    activity_index.value = index
    edit_activity_dialog.value = true
}

const create_new_activity_dialog = ref(false)
const create_new_activity = () => {
    create_new_activity_dialog.value = true
}

const save_new_activity = () => {
    loader.value = true
    let activity_type = "note"
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/create-activity', {"activity": activity.value, "company_id": props.company_id, "type": activity_type})
    .then(response => {
        console.log("activity saved", response.data)
        get_activities()
        loader.value = false
        create_new_activity_dialog.value = false
        toast.add({severity: 'success', summary: 'Erfolg', detail: 'Notiz erfolgreich erstellt', life: 3000})
    })
}

const save_edit_activity = () => {
    loader.value = true
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/edit-activity', {"activity": activity.value, "index": activity_index.value, "company_id": props.company_id})
    .then(response => {
        console.log("activity saved", response.data)
        get_activities()
        loader.value = false
        edit_activity_dialog.value = false
        toast.add({severity: 'success', summary: 'Erfolg', detail: 'Notiz erfolgreich aktualisiert', life: 3000})
    })
}

const delete_activity = (index) => {
    confirm.require({
        message: 'Möchten Sie diese Notiz wirklich löschen?',
        header: 'Notiz löschen?',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Ja, Notiz löschen',
        rejectLabel: 'Nein',
        acceptClass: 'p-button-danger',
        accept: () => {
            loader.value = true
            axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/delete-activity', {"index": index, "company_id": props.company_id})
            .then(response => {
                console.log("activity deleted", response.data)
                get_activities()
                loader.value = false
                toast.add({severity: 'success', summary: 'Erfolg', detail: 'Notiz erfolgreich gelöscht', life: 3000})
            })
        }
    })
}

const get_stage_fields = (pipeline, stage) => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-stage-fields?pipeline=' + pipeline + '&stage=' + stage)
    .then(response => {
        console.log("stage_fields", response.data)
        stage_fields.value = response.data
        tab_counter_stage.value = check_required_fields_stage()
        loader.value = false
    })
}

const update_stage_fields = (field_id, field_value) => {
    console.log("update stage fields", company.value)
    save_company()
}

const create_deal = () => {
    loader.value = true
    if (activity.value) {
        save_new_activity()
    }
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/create-deal', {"pipeline": pipeline.value, "company_id": props.company_id, "stage_id": company.value.change_deal})
    .then(response => {
        console.log("deal created", response.data)
        get_company()
        toast.add({severity: 'success', summary: 'Erfolg', detail: 'Vorprojekt erfolgreich erstellt', life: 3000})
        loader.value = false
        create_deal_dialog.value = false
    })
}

const delete_deal = () => {
    confirm.require({
        message: 'Möchten Sie diesen Vorprojekt wirklich löschen?',
        header: 'Vorprojekt löschen?',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Ja, Vorprojekt löschen',
        rejectLabel: 'Nein',
        acceptClass: 'p-button-danger',
        accept: () => {
            loader.value = true
            axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/delete-deal', {"pipeline": pipeline.value, "deal_id": company.value.deal_id})
            .then(response => {
                console.log("deal deleted", response.data)
                get_company()
                loader.value = false
                toast.add({severity: 'success', summary: 'Erfolg', detail: 'Vorprojekt erfolgreich gelöscht', life: 3000})
            })
        }
    })
}

const change_stage = () => {
    loader.value = true
    if (activity.value) {
        save_new_activity()
    }
    if (change_stage_id.value == null) {
        change_stage_id.value = company.value.change_stage
    }
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/change-stage', {"pipeline": pipeline.value, "deal_id": company.value.deal_id, "stage_id": change_stage_id.value, "company": company.value})
    .then(response => {
        console.log("stage changed", response.data)
        get_company()
        loader.value = false
        toast.add({severity: 'success', summary: 'Erfolg', detail: 'Vorprojekt erfolgreich aktualisiert', life: 3000})
    })
}

const create_contact = () => {
    contact.value.id = null
    contact.value.first_name = ""
    contact.value.last_name = ""
    contact.value.email = ""
    contact.value.phone = ""
    contact.value.anrede = ""
    contact.value.sprache = ""
    contact.value.company_id = company.value.id
    console.log("new contact", contact.value)
    edit_contact_dialog.value = true
}

const save_contact = () => {
    loader.value = true
    contact.value["company_id"] = props.company_id
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/save-contact', contact.value)
    .then(response => {
        console.log("contact saved", response.data)
        loader.value = false
        get_company()
        edit_contact_dialog.value = false
        toast.add({severity: 'success', summary: 'Erfolg', detail: 'Kontakt erfolgreich aktualisiert', life: 3000})
    })
}

const contact = ref({})
const edit_contact_dialog = ref(false)
const edit_contact = (data) => {
    contact.value = data
    console.log("edit contact", contact.value)
    edit_contact_dialog.value = true
}

const delete_contact = (id) => {
    confirm.require({
        message: 'Möchten Sie diesen Kontakt wirklich löschen?',
        header: 'Kontakt löschen?',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Ja, Kontakt löschen',
        rejectLabel: 'Nein',
        acceptClass: 'p-button-danger',
        accept: () => {
            loader.value = true
            axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/delete-contact', {"id": id, "company_id": props.company_id})
            .then(response => {
                console.log("contact deleted", response.data)
                get_company()
                loader.value = false
                toast.add({severity: 'success', summary: 'Erfolg', detail: 'Kontakt erfolgreich gelöscht', life: 3000})
            })
        }
    })
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const org_files = ref({})
const org_files_total = ref(0)
const selected_category = ref("")
const selected_file_category = ref("")
const files_explorer = ref([])
const get_company_files = async () => {
    await axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/get-organization-files', {"org_id": props.company_id})
    .then(response => {
        console.log("files", response.data)
        org_files.value = response.data
        org_files_total.value = response.data.counts.total
        if (response.data.counts.total > 0) {
            selected_file_category.value = Object.keys(org_files.value['files'])[0]
            files_explorer.value = org_files.value['files'][selected_category.value]
        }
    })
}

const delete_company = (id) => {
    confirm.require({
        message: 'Möchten Sie diese Objekt wirklich löschen?',
        header: 'Objekt löschen?',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Ja, Objekt löschen',
        rejectLabel: 'Nein',
        acceptClass: 'p-button-danger',
        accept: () => {
            loader.value = true
            axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/delete-company', {"id": props.company_id})
            .then(response => {
                console.log("company deleted", response.data)
                loader.value = false
                toast.add({severity: 'success', summary: 'Erfolg', detail: 'Objekt erfolgreich gelöscht', life: 3000})
                location.reload()
            })
        }
    })
}


const open_url = (url) => {
    window.open(url, '_blank')
}

const format_swiss_date = (value) => {
    if (!value || value.length != 24 && value.length != 10) return ""
    return value.substring(8,10) + '.' + value.substring(5,7) + '.' + value.substring(0,4)
}

const format_swiss_date_time = (value) => {
    return value.substring(8,10) + '.' + value.substring(5,7) + '.' + value.substring(0,4) + " " + value.substring(11,16)
}

const download_file = (file_id, file_name) => {
    window.open(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/pipedrive-download-file?file_id=' + file_id + '&file_name='+file_name, '_blank')
}

</script>
<style lang="scss" scoped>
    @import '@/core/assets/primevue/primeflex.scss';
</style>
<template>
    <ProgressSpinner v-if="loader" style="width:50px;height:50px" strokeWidth="8" animationDuration="1.5s" aria-label="Custom ProgressSpinner" class="spinner" />
    <Toast />
    <div v-if="!loader">
        <div class="flex align-items-center justify-content-end">
            <Button v-if="!company['deal_id']" icon="pi pi-plus" class="p-button-rounded mr-2 bg-green-200 text-black-alpha-90 border-green-200" label="Vorprojekt starten" @click="create_deal_dialog = true, company.change_deal = null, activity = null" />
            <Button icon="pi pi-plus" class="p-button-rounded mr-2" label="Notiz hinzufügen" @click="create_new_activity()" />
            <Button icon="pi pi-plus" class="p-button-rounded mr-2" label="Dateien hinzufügen" @click="new_file()" />
        </div>
        <div>
            <span class="mr-2 ml-3 font-bold text-2xl">{{company.name}}</span>
        </div>
        <TabView class="w-full mt-2" :scrollable="true">
            <TabPanel v-if="company.stage">
                <template #header>
                    <div class="flex align-play-circle gap-2">
                        <Avatar icon="pi pi-folder" shape="circle" class="bg-primary text-white mr-2" />
                        <span class="font-bold white-space-nowrap">Vorprojekt</span>
                        <Badge v-if="tab_counter_stage > 0" :value="String(tab_counter_stage)" class="ml-2 bg-red-600 text-white" />
                        <Badge v-else :value="String(0)" class="ml-2 bg-gray-100 text-black-alpha-90" />
                    </div>
                </template>
                <div class="grid">
                    <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Planer
                    </div>
                    <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Chip v-if="company.owner" icon="pi pi-user" :label="get_user_full_name(company.owner)" class="mr-2 bg-primary text-white cursor-pointer" />
                        <i class="pi pi-pencil cursor-pointer text-primary hover:text-black-alpha-90" @click="edit_company()" />
                    </div>
                    <div v-if="company.stage == 'NEU'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                        Herkunft
                    </div>
                    <div v-if="company.stage == 'NEU'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown id="owner" v-model="company.lead_source" :options="lead_sources" showClear optionLabel="name" optionValue="value" class="w-full" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'NEU' && company.owner" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                        Status
                    </div>
                    <div v-if="company.stage == 'NEU' && company.owner" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown id="owner" v-model="company.neu_status" :options="neu_statuses" showClear optionLabel="name" optionValue="value" class="w-full" @change="save_neu_status()" />
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Onboarding an Kunden senden
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown v-model="company.send_onboarding_via" :options="send_offer_vias" showClear optionLabel="name" optionValue="value" class="w-auto mr-2" @change="save_company()" />
                        <Dropdown v-model="company.send_onboarding_to" :options="company.contacts" showClear optionLabel="first_name" optionValue="email" class="w-auto mr-2" @change="save_company()" />
                        <Button icon="pi pi-send" class="p-button-rounded p-button-text mr-2" label="Onboarding senden" @click="send_onboarding()" />
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Vorprojekt kosten
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown v-model="company.project_costs" :options="project_costs" showClear optionLabel="name" optionValue="value" class="w-full" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase' && company.project_costs == 0" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Sonstiger Betrag
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase' && company.project_costs == 0" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <InputNumber v-model="company.project_custom_costs" mode="currency" currency="CHF" locale="de-CH" class="w-full" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase' && company.project_costs > 0 || company.stage == 'VP Offertenphase' && company.project_custom_costs > 0" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Offerte an Kunden senden
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase' && company.project_costs > 0 || company.stage == 'VP Offertenphase' && company.project_custom_costs > 0" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Button icon="pi pi-eye" class="p-button-rounded p-button-text mr-2" label="Offerte ansehen" @click="view_offer()" />
                        <Dropdown v-model="company.send_offer_via" :options="send_offer_vias" showClear optionLabel="name" optionValue="value" class="w-auto mr-2" @change="save_company()" />
                        <Dropdown v-model="company.send_offer_to" :options="company.contacts" showClear optionLabel="first_name" optionValue="email" class="w-auto mr-2" @change="save_company()" />
                        <Button icon="pi pi-send" class="p-button-rounded p-button-text mr-2" label="Offerte senden" @click="send_offer()" />
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase' && company.send_offer_to" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Offertenstatus
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase' && company.send_offer_to" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown v-model="company.offer_status" :options="offer_statuses" showClear optionLabel="name" optionValue="value" class="w-full" @change="save_offer_status()" />
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase' && company.offer_status == 'Vorprojekt abgesagt'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Absagegrund
                    </div>
                    <div v-if="company.stage == 'VP Offertenphase' && company.offer_status == 'Vorprojekt abgesagt'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Editor v-model="company.cancel_reason" class="w-full" editorStyle="height: 150px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>
                    <div v-if="company.stage == 'Vermessung'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Ausmessung
                    </div>
                    <div v-if="company.stage == 'Vermessung'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Checkbox v-model="company.ausmessung" :binary="true" class="ml-2" @change="save_ausmessung()" />
                    </div>
                    <div v-if="company.stage == 'Vermessung'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Bestand gezeichnet
                    </div>
                    <div v-if="company.stage == 'Vermessung'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Checkbox v-model="company.gezeichnet" :binary="true" class="ml-2" @change="save_gezeichnet()" />
                    </div>
                    <div v-if="company.stage == 'VP Planungsphase'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Entwurf fertig
                    </div>
                    <div v-if="company.stage == 'VP Planungsphase'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Checkbox v-model="company.entwurf_fertig" :binary="true" class="ml-2" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'VP Planungsphase'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Planvariante fertig 
                    </div>
                    <div v-if="company.stage == 'VP Planungsphase'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Checkbox v-model="company.planvariante_fertig" :binary="true" class="ml-2" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'VP Planungsphase' && company.planvariante_fertig == true" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Kundenreaktion 
                    </div>
                    <div v-if="company.stage == 'VP Planungsphase' && company.planvariante_fertig == true" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown v-model="company.kundenreaktion" :options="kundenreaktionen" showClear optionLabel="name" optionValue="value" class="w-full" @change="save_kundenreaktion()" />
                    </div>
                    <div v-if="company.stage == 'Offertenphase'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Voranfragen
                    </div>
                    <div v-if="company.stage == 'Offertenphase'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Textarea v-model="company.voranfragen" class="w-full" rows="5" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'Offertenphase'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Gartenbautechnik
                    </div>
                    <div v-if="company.stage == 'Offertenphase'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Textarea v-model="company.gartenbautechnik" class="w-full" rows="5" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'Offertenphase'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Projektleiter
                    </div>
                    <div v-if="company.stage == 'Offertenphase'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown v-model="company.uebergabe_an_projektleiter_user" :options="users" showClear optionLabel="full_name" optionValue="id" class="w-auto ml-2" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'Offertenphase' && company.uebergabe_an_projektleiter_user" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Offerte Wunschtermin
                    </div>
                    <div v-if="company.stage == 'Offertenphase' && company.uebergabe_an_projektleiter_user" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Calendar v-model="company.uebergabe_an_projektleiter_date" placeholder="Wunschtermin" :showIcon="true" :showButtonBar="true" :showOn="calendar" :dateFormat="'dd.mm.yy'" class="ml-2" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'Offertenphase' && company.uebergabe_an_projektleiter_user && company.uebergabe_an_projektleiter_date" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Übergabe von Planer an Projektleiter
                    </div>
                    <div v-if="company.stage == 'Offertenphase' && company.uebergabe_an_projektleiter_user && company.uebergabe_an_projektleiter_date" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Checkbox v-if="company.uebergabe_an_projektleiter_date" v-model="company.uebergabe_an_projektleiter" :binary="true" class="ml-2" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'Offertenphase' && company.uebergabe_an_planer_user" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Offerte bereit zur Besprechung
                    </div>
                    <div v-if="company.stage == 'Offertenphase' && company.uebergabe_an_planer_user" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Checkbox v-model="company.offerte_bereit_zur_besprechung" :binary="true" class="ml-2" @change="save_offerte_bereit()" />
                    </div>
                    <div v-if="company.stage == 'Offertenstatus'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Offertenstatus 
                    </div>
                    <div v-if="company.stage == 'Offertenstatus'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown v-model="company.offertenstatus" :options="offertenstatuses" showClear optionLabel="name" optionValue="value" class="w-full" @change="save_offertenstatus()" />
                    </div>
                    <div v-if="company.stage == 'AVOR'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Starttermin
                    </div>
                    <div v-if="company.stage == 'AVOR'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Calendar v-model="company.avor_starttermin" placeholder="Starttermin" :showIcon="true" :showButtonBar="true" :showOn="calendar" :dateFormat="'dd.mm.yy'" class="ml-2" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'AVOR'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Wunschpolier
                    </div>
                    <div v-if="company.stage == 'AVOR'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown placeholder="Wunschpolier auswählen" v-model="company.wunschpolier" :options="users" showClear optionLabel="full_name" optionValue="id" class="w-auto ml-2" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'AVOR'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Ausführungspläne erstellt
                    </div>
                    <div v-if="company.stage == 'AVOR'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Checkbox v-model="company.ausfuerungsplaene_erstellt" :binary="true" class="ml-2" @change="save_company()" />
                    </div>
                    <div v-if="company.stage == 'AVOR'" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.owner ? 'text-red-600' : ''" >
                        Begleitung von Projektleiter
                    </div>
                    <div v-if="company.stage == 'AVOR'" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown placeholder="Projektleiter auswählen" v-model="company.begleitung_projektleiter" :options="users" showClear optionLabel="full_name" optionValue="id" class="w-auto ml-2" @change="save_company()" />
                    </div>
                    <div v-for="(field, index) in stage_fields" :key="index" class="col-12 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <div v-if="field.type == 'text'">
                            <label :class="field.required && !company['stage_fields'][field.id] ? 'text-red-600' : ''" :for="field.id" class="font-bold mr-2">{{field.name}}</label>
                            <InputText :id="field.id" v-model="company['stage_fields'][field.id]" class="w-full mt-1" @change="update_stage_fields(field.id, company['stage_fields'][field.id])" />
                        </div>
                        <div v-if="field.type == 'number'">
                            <label :class="field.required && !company['stage_fields'][field.id] ? 'text-red-600' : ''" :for="field.id" class="font-bold mr-2">{{field.name}}</label>
                            <InputNumber :id="field.id" v-model="company['stage_fields'][field.id]" class="w-full mt-1" />
                        </div>
                        <div v-if="field.type == 'checkbox'">
                            <Checkbox :id="field.id" v-model="company['stage_fields'][field.id]" :binary="true" class="ml-2" @change="update_stage_fields(field.id, company['stage_fields'][field.id])" />
                            <label :class="field.required && !company['stage_fields'][field.id] ? 'text-red-600' : ''" :for="field.id" class="font-bold ml-2 mt-1">{{field.name}}</label>
                        </div>
                    </div>
                    <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                        Vorprojekt
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Chip icon="pi pi-folder" v-if="!company.change_stage" :label="company.stage" class="mr-2 bg-green-200 text-black-alpha-90 cursor-pointer mt-2" @click="router.push('/dashboard/vorprojekt?deal_id='+company.deal)" />
                        <i v-if="!company.change_stage" class="pi pi-pencil cursor-pointer text-primary hover:text-black-alpha-90" @click="company.change_stage = company.deal_id" />
                        <Dropdown v-if="company.change_stage" v-model="company.change_stage" :options="stages" showClear optionLabel="name" optionValue="id" class="mr-2" />
                    </div>
                    <div v-if="company.deal_id && company.change_stage" class="col-1 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <i class="pi pi-trash cursor-pointer text-red-600 hover:text-black-alpha-90 mt-2" @click="delete_deal(company.change_id)" />
                    </div>
                    <div v-if="company.change_stage" class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                        Bemerkungen
                    </div>
                    <div v-if="company.change_stage" class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Editor v-model="activity" class="w-full" editorStyle="height: 150px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>
                    <div v-if="company.change_stage" class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                        <Button @click="change_stage" :disabled="activity && company.change_stage ? false : true" label="Speichern" icon="pi pi-save" class="w-auto mr-2 bg-green-700 text-white border-green-600" />
                    </div>
                    <div v-if="!activity && company.change_stage" class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                        <small class="text-red-700">Achtung: Bitte alle Pflichtfelder ausfüllen</small>
                    </div>
                </div>
            </TabPanel>
            <TabPanel>
                <template #header>
                    <div class="flex align-items-center gap-2">
                        <Avatar icon="pi pi-building" shape="circle" class="bg-primary text-white mr-2" />
                        <span class="font-bold white-space-nowrap">Prospect</span>
                        <Badge v-if="tab_counter_company > 0" :value="String(tab_counter_company)" class="ml-2 bg-red-600 text-white" />
                        <Badge v-else :value="String(0)" class="ml-2 bg-gray-100 text-black-alpha-90" />
                    </div>
                </template>
                <div class="grid">
                    <div class="col-12 flex justify-content-end">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-text mr-2" label="Objekt bearbeiten" @click="edit_company()" />
                    </div>
                    <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.name ? 'text-red-600' : ''">
                        Namen
                    </div>
                    <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <span class="mr-2 font-bold">{{company.name}}</span>
                    </div>
                    <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.street ? 'text-red-600' : ''">
                        Strasse
                    </div>
                    <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <span class="mr-2">{{company.street}}</span>
                    </div>
                    <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.postal_code ? 'text-red-600' : ''">
                        PLZ
                    </div>
                    <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <span class="mr-2">{{company.postal_code}}</span></div>
                    <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap" :class="!company.city ? 'text-red-600' : ''">
                        Ort
                    </div>
                    <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <span class="mr-2">{{company.city}}</span>
                    </div>
                </div>
            </TabPanel>
            <TabPanel>
                <template #header>
                    <div class="flex align-items-center gap-2">
                        <Avatar icon="pi pi-users" shape="circle" class="bg-primary text-white mr-2" />
                        <span class="font-bold white-space-nowrap">Kontakte</span>
                        <Badge v-if="contacts.length > 0" :value="contacts.length" class="ml-2 bg-gray-100 text-black-alpha-90" />
                        <Badge v-else :value="contacts.length" class="ml-2 bg-red-600 text-white" />
                    </div>
                </template>
                <DataTable :value="contacts" responsiveLayout="scroll" :rowHover="true">
                    <Column style="width: 50px">
                        <template #body>
                            <Avatar icon="pi pi-user" shape="circle" class="mr-2 bg-primary text-white" />
                        </template>
                    </Column>
                    <Column header="Firmenkontakte">
                        <template #body="slotProps">
                            <div class="w-full">
                                <div class="flex align-items-center">
                                    <span v-if="slotProps.data.anrede && salutations" class="font-bold text-secondary mr-2">{{ slotProps.data.anrede }}</span>
                                    <span class="font-bold mr-2">{{slotProps.data.first_name}}</span>
                                    <span class="font-bold mr-2">{{slotProps.data.last_name}}</span>
                                </div>
                            </div>
                            <div class="w-full">
                                <div class="flex align-items-center">
                                    <span class="mr-2">{{slotProps.data.email}}</span>
                                    <i v-if="slotProps.data.email" class="pi pi-envelope mr-2 pointer-cursor text-primary" @click="open_url('mailto:'+slotProps.data.email)" />
                                </div>
                            </div>
                            <div class="w-full">
                                <div class="flex align-items-center">
                                    <span class="mr-2">{{slotProps.data.phone}}</span>
                                    <i v-if="slotProps.data.phone" class="pi pi-phone mr-2 pointer-cursor text-primary" @click="open_url('tel:'+slotProps.data.phone)" />
                                </div>
                            </div>
                            <div class="w-full">
                                <div class="flex align-items-center">
                                    <Tag v-if="slotProps.data.sprache && languages" :value="slotProps.data.sprache" class="bg-gray-100 text-gray-500" />
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column style="width: 150px">
                        <template #body="slotProps">
                            <Button rounded icon="pi pi-pencil" class="p-button p-button-text" @click="edit_contact(slotProps.data)" />
                            <Button rounded icon="pi pi-trash" class="p-button p-button-text p-button-danger" @click="delete_contact(slotProps.data.id, slotProps.data.name)" />
                        </template>
                        <template #header>
                            <Button rounded icon="pi pi-plus" class="p-button" @click="create_contact()" />
                        </template>
                    </Column>
                </DataTable>
            </TabPanel>
            <TabPanel>
                <template #header>
                    <div class="flex align-items-center gap-2">
                        <Avatar icon="pi pi-history" shape="circle" class="bg-primary text-white mr-2" />
                        <span class="font-bold white-space-nowrap">Verlauf</span>
                        <Badge :value="String(activities.length)" class="ml-2 bg-gray-100 text-black-alpha-90" />
                    </div>
                </template>
                <div>
                    <div v-for="(activity, index) in activities" :key="activity" rounded class="overflow-hidden shadow-3 border-200 mt-3 pl-2">
                        <div v-if="activity.type == 'note'" class="grid">
                            <div class="col-8 flex align-items-center border-blue-100 border-solid border-bottom-1 bg-blue-50 p-3 mt-2">
                                <Avatar icon="pi pi-user" shape="circle" class="bg-primary text-white mr-2" />
                                <span class="font-bold mr-2">{{ get_user_full_name(activity.user) }}</span>
                                <span class="text-gray-500 mr-2">@ {{format_swiss_date_time(activity.timestamp)}}</span>
                            </div>
                            <div class="col-4 flex align-items-center justify-content-end border-blue-100 border-solid border-bottom-1 bg-blue-50">
                                <Button icon="pi pi-pencil" class="p-button-rounded p-button-text" @click="edit_activity(index)" />
                                <Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger mr-2" @click="delete_activity(index)" />
                            </div>
                            <div class="col-12 p-5">
                                <span v-html="activity.content"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </TabPanel>
            <TabPanel>
                <template #header>
                    <div class="flex align-items-center gap-2">
                        <Avatar icon="pi pi-file" shape="circle" class="bg-primary text-white mr-2" />
                        <span class="font-bold white-space-nowrap">Dokumente</span>
                        <Badge :value="String(org_files_total)" class="ml-2 bg-gray-100 text-black-alpha-90" />
                    </div>
                </template>
                <div>
                    <Chip v-for="org_file, key in org_files['files']" :key="key" class="bg-black-alpha-90 text-white mr-2 p-2 hover:bg-primary cursor-pointer" :class="selected_category == key ? 'bg-primary' : 'bg-black-alpha-90'" @click="files_explorer = org_file, selected_category = key">
                        <i class="pi pi-folder" style="margin-right: 0.5rem"></i>
                        <span>{{ key }}</span>
                        <Badge :value="String(org_file.length)" class="ml-2 bg-gray-100 text-black-alpha-90" />
                    </Chip>
                </div>
                <div>
                    <div v-for="file_explorer in files_explorer" :key="file_explorer" rounded class="overflow-hidden shadow-3 border-200 mt-3">
                        <div class="col-12 flex align-items-center border-blue-100 border-solid border-bottom-1 bg-blue-50 p-3 mt-2 ml-2">
                            <Avatar icon="pi pi-file" shape="circle" class="bg-primary text-white mr-2" />
                            <span class="font-bold mr-2">{{ file_explorer.name }}</span>
                            <span class="text-gray-500 mr-2">@ {{ format_swiss_date_time(file_explorer.add_time) }}</span>
                        </div>
                        <div class="col-12 p-5">
                            <span class="font-bold text-primary mr-2 cursor-pointer" @click="download_file(file_explorer.id, file_explorer.file_name)">{{ file_explorer.file_name }}</span>
                            <Chip :label="file_explorer.file_type" class="mr-2" />
                        </div>
                    </div>
                </div>
            </TabPanel>
        </TabView>
    </div>

    <Dialog v-model:visible="edit_contact_dialog" :style="{width: '70%'}" header="Kontaktdaten" :modal="true" class="p-fluid z-5">
        <div class="grid">
            <div class="col-6 mt-4">
                <span class="p-float-label">
                    <InputText id="first_name" v-model="contact.first_name" />
                    <label for="first_name">Vorname</label>
                </span>
            </div>
            <div class="col-6 mt-4">
                <span class="p-float-label">
                    <InputText id="last_name" v-model="contact.last_name" />
                    <label for="last_name">Nachname</label>
                </span>
            </div> 
            <div class="col-6 mt-4">
                <span class="p-float-label">
                    <InputText id="email" v-model="contact.email" />
                    <label for="email">E-Mail</label>
                </span>
            </div>
            <div class="col-6 mt-4">
                <span class="p-float-label">
                    <InputText id="phone" v-model="contact.phone" />
                    <label for="phone">Telefon</label>
                </span>
            </div>
            <div class="col-6 mt-4">
                <span class="p-float-label">
                    <Dropdown id="salutations" v-model="contact.anrede" :options="salutations" optionLabel="label" optionValue="id" class="w-full" />
                    <label for="salutations">Anrede</label>
                </span>
            </div>
            <div class="col-12 mt-4">
                <Button label="Speichern" icon="pi pi-check" class="mr-2 w-auto" @click="save_contact()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="edit_contact_dialog = false" />
            </div>
        </div>
    </Dialog>

    <Dialog v-model:visible="create_new_activity_dialog" :style="{width: '50%'}" :header="'Notiz hinzufügen:  '+company.name" :modal="true" class="p-fluid z-5">
        <div class="grid">
            <div class="col-12">
                <Editor v-model="activity" editorStyle="height: 320px">
                    <template v-slot:toolbar>
                        <span class="ql-formats">
                            <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                            <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                            <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                            <button v-tooltip.bottom="'Strike'" class="ql-list"></button>
                        </span>
                    </template>
                </Editor>
            </div>
            <div class="col-12">
                <Button label="Speichern" icon="pi pi-check" class="mr-2 w-auto" @click="save_new_activity()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="create_new_activity_dialog = false" />
            </div>
        </div>
    </Dialog>

    <Dialog v-model:visible="edit_activity_dialog" :style="{width: '50%'}" :header="'Notiz bearbeiten:  '+company.name" :modal="true" class="p-fluid z-5">
        <div class="grid">
            <div class="col-12">
                <Editor v-model="activity" editorStyle="height: 320px">
                    <template v-slot:toolbar>
                        <span class="ql-formats">
                            <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                            <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                            <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                            <button v-tooltip.bottom="'Strike'" class="ql-list"></button>
                        </span>
                    </template>
                </Editor>
            </div>
            <div class="col-12">
                <Button label="Speichern" icon="pi pi-check" class="mr-2 w-auto" @click="save_edit_activity()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="edit_activity_dialog = false" />
            </div>
        </div>
    </Dialog>

    <Dialog v-model:visible="create_deal_dialog" :style="{width: '80%'}" :header="'Vorprojekt starten:  '+company.name" :modal="true" class="p-fluid z-5">
        <div class="grid">
            <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                Projektnamen
            </div>
            <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="company.name" class="w-full" />
            </div>
            <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                Phase
            </div>
            <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Dropdown v-model="company.change_deal" :options="stages" optionLabel="name" optionValue="id" class="w-full" />
            </div>
            <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-content-center flex-wrap">
                Bemerkung (Optional)
            </div>
            <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Editor v-model="activity" editorStyle="height: 320px">
                    <template v-slot:toolbar>
                        <span class="ql-formats">
                            <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                            <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                            <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                            <button v-tooltip.bottom="'Strike'" class="ql-list"></button>
                        </span>
                    </template>
                </Editor>
            </div>
            <div class="col-12">
                <Button :disabled="!company.change_deal ? true : false" label="Vorprojekt starten" icon="pi pi-check" class="mr-2 w-auto" @click="create_deal()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="create_deal_dialog = false" />
            </div>
        </div>
    </Dialog>

    <Sidebar v-model:visible.sync="edit_company_slider" position="left" style="width: 50%">
        <div class="grid">
            <div class="col-12 mt-3">
                <span class="p-float-label">
                    <InputText id="name" v-model="company.name" class="w-full" />
                    <label for="name">Name</label>
                </span>
            </div>
            <div class="col-6 mt-3">
                <span class="p-float-label">
                    <InputText id="street" v-model="company.street" class="w-full" />
                    <label for="street">Strasse</label>
                </span>
            </div>
            <div class="col-6 mt-3">
                <span class="p-float-label">
                    <InputText id="postal_code" v-model="company.postal_code" class="w-full" />
                    <label for="postal_code">PLZ</label>
                </span>
            </div>
            <div class="col-6 mt-3">
                <span class="p-float-label">
                    <InputText id="city" v-model="company.city" class="w-full" />
                    <label for="city">Ort</label>
                </span>
            </div>
            <div class="col-6 mt-3">
                <span class="p-float-label">
                    <Dropdown id="owner" v-model="company.owner" :options="users" showClear optionLabel="full_name" optionValue="email" class="w-full" />
                    <label for="owner">Planer</label>
                </span>
            </div>
            <div class="col-12 mt-5">
                <Button label="Speichern" icon="pi pi-check" class="mr-2 w-auto" @click="save_company()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="edit_company_slider = false" />
            </div>
        </div>
    </Sidebar>
</template>